import React from 'react';
import PropTypes, { string } from 'prop-types';
import i18next from 'i18next';

import { MODALS } from '~redux/Modal/constants';
import CustomModal from '~components/CustomModal';
import SectionTitle from '~components/SectionTitle';
import { addressPropTypes } from '~propTypes/address';
import DeliveryOrPickUp from '~components/DeliveryOrPickUp';
import StoreSearchBar from '~components/StoreSearchBar';
import shapeStore from '~constants/propTypes';

import { DISPATCH_METHOD } from '../../screens/Orders/components/ActualOrder/constants';

import { DEFAULT_MAX_RESULTS } from './constants';
import styles from './styles.module.scss';

const ChangeAddress = ({
  isOpen,
  onConfirm,
  selectedAddress,
  lastAddresses,
  onAddressSelect,
  onSearchInputChange,
  isAddressReady,
  hideCloseButton,
  storeChanged = false,
  stores,
  onStoreSelect,
  selectedStore,
  selectedDispatchMethod,
  changeDeliveryMethod,
  onClose
}) => (
  <CustomModal
    hideCloseButton={hideCloseButton}
    shouldCloseOnOverlayClick={!hideCloseButton}
    modal={MODALS.DELIVERY_OR_PICKUP}
    isOpen={isOpen}
    className={styles.containerModalDop}
    onClose={onClose}>
    <div className="row full-width">
      <div className="column top full-height full-width">
        <SectionTitle titleClassName={styles.titleForm} className="m-bottom-2" noSeparator>
          {i18next.t('DeliveryOrPickup:howDoYouWantToOrderToday')}
        </SectionTitle>
        {!isAddressReady && (
          <div className={`${styles.deliveryOrPickupSeparator}`}>
            <i className="icon-delivery_dining" />
            {i18next.t('DeliveryOrPickUp:delivery')}
          </div>
        )}
        {storeChanged && (
          <span className={styles.subtitle}>{i18next.t('DeliveryOrPickup:addressNoLongerAvailable')}</span>
        )}
        <StoreSearchBar
          key="modalSearchBar"
          maxResults={DEFAULT_MAX_RESULTS}
          selectedAddress={selectedAddress}
          onAddressSelect={onAddressSelect}
          onChange={onSearchInputChange}
          onClean={onSearchInputChange}
          className={styles.searchBar}
          lastAddresses={lastAddresses}
          selectedDispatchMethod={!isAddressReady ? selectedDispatchMethod : DISPATCH_METHOD.DELIVERY}
          onClick={changeDeliveryMethod}
        />
        {isAddressReady ? (
          <DeliveryOrPickUp
            selectedAddress={selectedAddress}
            onConfirm={onConfirm}
            selectedStore={selectedStore}
            onStoreSelect={onStoreSelect}
            selectedDispatchMethod={selectedDispatchMethod}
          />
        ) : (
          <div className="column full-width">
            {stores && (
              <div className={`column item-1 ${styles.addressGroup}`}>
                <div className={`${styles.deliveryOrPickupSeparator}`}>
                  <i className="icon-store_mall_directory" />
                  {i18next.t('DeliveryOrPickUp:local')}
                </div>
                <div className="column full-width middle m-bottom-4">
                  <p className="text-base text-center">
                    {i18next.t('DeliveryOrPickup:pickOneOfOurStoresToPickup')}
                  </p>
                </div>
                <DeliveryOrPickUp
                  selectedAddress={selectedAddress}
                  onConfirm={onConfirm}
                  onAddressSelect={onAddressSelect}
                  selectedStore={selectedStore}
                  onStoreSelect={onStoreSelect}
                  selectedDispatchMethod={selectedDispatchMethod}
                  onlyPickup
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  </CustomModal>
);

ChangeAddress.propTypes = {
  onSearchInputChange: PropTypes.func.isRequired,
  changeDeliveryMethod: PropTypes.func,
  hideCloseButton: PropTypes.bool,
  isAddressReady: PropTypes.bool,
  isOpen: PropTypes.bool,
  lastAddresses: PropTypes.arrayOf(addressPropTypes),
  selectedAddress: addressPropTypes,
  selectedDispatchMethod: string,
  selectedStore: PropTypes.shape(shapeStore),
  storeChanged: PropTypes.bool,
  stores: PropTypes.arrayOf(shapeStore),
  onAddressSelect: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onStoreSelect: PropTypes.func
};

export default ChangeAddress;
